var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vPage',[_c('vBookHeader',{attrs:{"name":"Pikkutieto: mennään piiloon","ingress":"Plop tutkii, mitä kaikkea näkymätöntä ympärillämme häärii. On monta tapaa mennä piiloon.","coAuthor":"Kuvittaja Sanna Pelliccioni","publisher":"Karisto","published":"2021","flag":"Tulossa"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25f56430","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/books/PikkuTietoMennaanPiiloon.vue
// module id = null
// module chunks = 